import React, { FC, ReactNode } from "react";
import styles from "./PointList.module.scss";

export const Point: FC<{
  children?: ReactNode;
}> = ({ children }) => {
  return <li className={styles.point}>{children}</li>;
};
